export default "__VITE_ASSET__BosBSwuy__"